import { useCallback, useEffect, useState } from "react";

// Runs an editor API call against the working model, with loading/error state.
export function useDeliverable(fn, deps = [], enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await fn();
      setData(r);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setLoading(false);
    }
  }, deps); // eslint-disable-line

  useEffect(() => {
    if (enabled) reload();
  }, [reload, enabled]);

  return { data, loading, error, reload };
}
